import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FlowMaterialModule } from '@app/flow-material.module';

import { DocumentSearchDialog } from './document-search.dialog';

const dialogs = [DocumentSearchDialog];

@NgModule({
    declarations: dialogs,
    exports: dialogs,
    imports: [CommonModule, FlowMaterialModule, FormsModule, ReactiveFormsModule]
})
export class DocumentSearchDialogModule {}
